// extracted by mini-css-extract-plugin
export default {"loading":"SubmitButton_loading__1aYZ6"};